<template>
  <div v-if="selectedReservation">
    <div class="modal fade" role="dialog" ref="reservationrepricemodal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new">
            <div class="row">
              <div class="col-sm-10">
                <h4>Tenant Reprice</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <!-- Start: Form -->
                  <div class="row">
                    <div class="col-sm-6">
                      <!-- <h4>
                        Provider Reservation Reprice
                        <span class="text-edited" v-if="isUpdate"></span>
                      </h4> -->

                      <div style="margin-bottom: 20px">
                        <div>
                          <!-- <nav aria-label="breadcrumb">
                            <ol class="breadcrumb mb-35 pz">
                              <li class="breadcrumb-item">
                                <router-link :to="'/job/provider'"> Provider Job </router-link>
                              </li>
                              <li class="breadcrumb-item active" aria-current="page">Detail</li>
                            </ol>
                          </nav> -->
                          <!-- <div class="table-legend">
                            <ul>
                              <li v-if="isAirportTransfer">
                                <i class="ic-flight-icon"></i>Airport Transfer
                              </li>
                              <li v-else><i class="ic-time"></i>Hourly Booking</li>
                            </ul>
                          </div> -->
                          <h4>Jobs Detail</h4>
                          <!-- <div :class="progressClassName"></div> -->
                        </div>
                        <!-- <div class="label-group">
                          <div class="label">Payment Status</div>
                          <div class="label-title">
                            <span
                              :class="{
                                '--green35': reservationDetail.paymentStatus === 'Complete',
                                'sts-danger': reservationDetail.paymentStatus !== 'Complete',
                              }"
                              >{{ reservationDetail.paymentStatus }}</span
                            >
                          </div>
                        </div> -->
                        <!-- <div class="label-group">
                          <div class="label">Payment Method</div>
                          <div class="label-title">
                            <span>{{ humanize(reservationDetail.paymentMethod) }}</span>
                          </div>
                        </div> -->
                        <div class="label-group">
                          <div class="label">Reservation Code</div>
                          <div class="label-title">
                            <span>{{ reservationDetail.code }}</span>
                          </div>
                        </div>
                        <div class="label-group">
                          <div class="label">Reservation Date</div>
                          <div class="label-title">
                            <span>{{
                              reservationDetail.reservationDate.stringFullDate
                            }}</span>
                          </div>
                        </div>
                        <div class="label-group" v-if="reservationDetail.driver">
                          <div class="label">Driver Name</div>
                          <div class="label-title --blue25">
                            <span
                              >{{ reservationDetail.driver.title }}.
                              {{ reservationDetail.driver.fullName }}</span
                            >
                          </div>
                        </div>
                        <div class="label-group" v-if="reservationDetail.driver">
                          <div class="label">Driver Phone</div>
                          <div class="label-title">
                            <span>{{
                              reservationDetail.driver.phoneCode &&
                              reservationDetail.driver.phoneNumber
                                ? `(+${reservationDetail.driver.phoneCode}) ${reservationDetail.driver.phoneNumber}`
                                : "N/A"
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <!-- <span>Add or Update extra service</span>
                      <h6>Please fill all information below.</h6>
                      <form role="form" action="#" id="master-class-rental-rate-form">
                        <div class="row">
                          <div class="col-sm-12 prz">
                            <div class="form-group">
                              <label class="required">Extra Service</label>
                              <select
                                class="form-control v-select"
                                name="type"
                                v-model="newFareComponent.name"
                                v-on:change="changeAncillaryItem($event)"
                                required
                              >
                                <option value>- Please Select -</option>
                                <option
                                  v-for="item in postbookingAncillaries"
                                  :value="item.name"
                                  :key="item.name"
                                >
                                  {{ item.name }}
                                </option>
                              </select>
                              <small
                                class="form-text text-danger"
                                v-if="validationErrors.type"
                                v-text="validationErrors.type"
                              ></small>
                            </div>
                          </div>
                          <div class="col-sm-6" hidden="hidden">
                            <div class="form-group">
                              <label class="required">Rate</label>
                              <input
                                class="form-control"
                                type="number"
                                name="duration"
                                v-model="newFareComponent.rate"
                                placeholder="100"
                                min="0"
                                required
                              />
                              <small
                                class="form-text text-danger"
                                v-if="validationErrors.duration"
                                v-text="validationErrors.duration"
                              ></small>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6 prz" hidden="hidden">
                            <div class="form-group">
                              <label class="required">
                                Quantity
                                <span class="--grey50"
                                  >({{ reservationDetail.currencyCode }})</span
                                >
                              </label>
                              <input
                                class="form-control"
                                type="number"
                                name="rate"
                                v-model="newFareComponent.quantity"
                                placeholder="Enter quantity"
                                @change="calculateAncillaryTotal()"
                                min="1"
                                step="any"
                                required
                              />
                              <small
                                class="form-text text-danger"
                                v-if="validationErrors.rate"
                                v-text="validationErrors.rate"
                              ></small>
                            </div>
                          </div>
                          <div class="col-sm-12 prz">
                            <label class="required">
                              Price
                              <span class="--grey50"
                                >({{ reservationDetail.currencyCode }})</span
                              >
                            </label>
                            <input
                              class="form-control"
                              type="number"
                              name="duration"
                              v-model="newFareComponent.rate"
                              placeholder="Enter price"
                              min="0"
                              required
                            />
                            <small
                              class="form-text text-danger"
                              v-if="validationErrors.duration"
                              v-text="validationErrors.duration"
                            ></small>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="reset()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isCanPropose()"
                            type="submit"
                            class="btn btn-primary"
                            @click.prevent="createItem()"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate"
                            type="submit"
                            class="btn btn-primary"
                            @click.prevent="updateItem()"
                          >
                            Update
                          </button>
                        </div>
                      </form> -->

                      <span><strong>Paid Components</strong></span>
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th class="number">No</th>
                            <th>Name</th>
                            <th>Category</th>
                            <th>
                              <label>
                                Rate
                                <span class="--grey50"
                                  >({{ reservationDetail.currencyCode }})</span
                                >
                              </label>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in reservationDetail.fareComponentsPreBooking"
                            :key="item.name"
                          >
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.category }}</td>
                            <td class="text-right">{{ item.rate }}</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Sub Total</td>
                            <td></td>
                            <td class="text-right">
                              {{ reservationDetail.buyingGrandTotal }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- End: Form -->

                  <!-- Start: Table -->
                  <div class="table-modal-detail">
                    <div class="table-responsive table-accordion">
                      <span><strong>Extra Services</strong></span>
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th class="number">No</th>
                            <th>Name</th>
                            <th class="text-right">
                              <label>
                                Quantity
                                <!-- <span class="--grey50"
                                  >({{ reservationDetail.currencyCode }})</span
                                > -->
                              </label>
                            </th>
                            <!-- <th class="text-center">Action</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in reservationDetail.fareComponentsPostBooking"
                            :key="item.id"
                          >
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ item.name }}</td>
                            <td class="text-right">{{ item.quantity }}</td>
                            <!-- <td class="text-center">
                              <div class="button-action-wrapper">
                                <button v-if="isCanPropose()"
                                  class="btn btn-default"
                                  type="button"
                                  @click="bindModel(item)"
                                >
                                  <span>Edit</span>
                                </button>
                                <button v-if="isCanPropose()"
                                  class="btn btn-default"
                                  type="button"
                                  @click="confirmDelete(item)"
                                >
                                  <i class="ic-close"></i>
                                </button>
                              </div>
                            </td> -->
                          </tr>
                          <tr>
                            <td></td>
                            <td>Sub Total</td>
                            <td class="text-right">{{ totalExtraService }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />
                    <div>
                      <span>Total Cost</span>
                      <table class="table">
                        <thead>
                          <tr>
                            <th class="text-right">
                              <label>
                                Grand Total
                                <span class="--grey50"
                                  >({{ reservationDetail.currencyCode }})</span
                                >
                              </label>
                            </th>
                            <th class="text-right">
                              <label>
                                Remaining
                                <span class="--grey50"
                                  >({{ reservationDetail.currencyCode }})</span
                                >
                              </label>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-right">{{ totalCost }}</td>
                            <td class="text-right">{{ totalExtraService }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- End: Table -->
                  <!-- <div>
                    <span v-if="isWaitForProposed()" style="color:red">
                      (Waiting Provider to propose price)
                    </span>
                  </div> -->
                  <!-- <div>
                    <button
                      v-if="isProposed()"
                      type="submit"
                      class="btn btn-primary"
                      @click.prevent="approve()"
                    >
                      APPROVE
                    </button>
                    <button
                      v-if="isApproved() && !isInvoiced()"
                      type="submit"
                      class="btn btn-primary"
                      @click.prevent="publishInvoice()"
                    >
                      INVOICE
                    </button>
                    <button
                      v-if="isProposed()"
                      type="submit"
                      class="btn btn-danger"
                      @click.prevent="reject()"
                    >
                      REJECT
                    </button>
                    <button
                      v-if="isInvoiced()"
                      type="submit"
                      class="btn btn-danger"
                      @click.prevent="close()"
                    >
                      CLOSE
                    </button>
                  </div> -->
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import inquiryProviderJobService from "@/services/job/providerJob/inquiryProviderJobService.js";
import inquiryTenantJobService from "@/services/job/tenantJob/inquiryTenantJobService.js";
import depositSummaryService from "@/services/master/deposit/depositSummaryService.js";
import inquiryReservationService from "@/services/shop/reservation/inquiryReservationService.js";
import extraService from "@/services/master/sellingTariff/sellingTariffAncillaryRateService.js";
import { constants } from "zlib";

export default {
  data() {
    return {
      isLoading: false,
      selectedReservation: {},
      reservationDetail: {
        booker: {},
        serviceType: "",
        code: "",
        driver: {},
        reservationDate: { stringFullDate: "" },
        passengers: [],
        pickUpDate: {},
        pickUpLocation: {},
        dropOffDate: {},
        dropOffLocation: {},
        className: "",
        paymentStatus: "",
        currencyCode: "",
        grandTotal: "",
        buyingGrandTotal: "",
        histories: [],
        fareComponents: [],
        fareComponentsSelling: [],
        fareComponentsBuying: [],
        fareComponentsPreBooking: [],
        fareComponentsPostBooking: [],
      },
      postbookingAncillaries: [],
      originalAncillaries: [],
      selectedAncillary: {},
      newFareComponent: {
        id: "",
        name: "",
        masterClassAncillaryId: "",
        quantity: 1,
      },
      newFareTotal: 0,
      isUpdate: false,
      model: {},
      totalCost: 0,
      totalExtraService: 0,

      validationErrors: {
        type: null,
        duration: null,
        rate: null,
      },
      currencyCode: "",
      msg: "Please wait",
    };
  },
  created() {
    // subscribe message
    this.$eventBus.$on("initializeReservationReprice", this.initialize);
    this.$eventBus.$on("deleteFareComponent", this.deleteItem);
    this.$eventBus.$on("openModalReservationReprice", this.openModal);
  },
  updated() {
    const self = this;
    $("#startPeriod-rental-wrapper .datepicker-day").on("click", function () {
      self.minimumEndPeriod = self.model.startPeriod;
    });
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeReservationReprice");
    this.$eventBus.$off("deleteFareComponent");
    this.$eventBus.$off("openModalReservationReprice");
  },
  methods: {
    openModal() {
      $(this.$refs.reservationrepricemodal).modal();
      $(this.$refs.reservationrepricemodal).css("overflow-y", "auto");
    },
    closeModal() {
      $(this.$refs.reservationrepricemodal).modal("hide");
    },
    async initialize(item) {
      try {
        this.isLoading = true;
        this.reset();
        this.selectedReservation = item;
        await this.getAll();
        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    resetValidation() {
      this.validationErrors.type = null;
      this.validationErrors.duration = null;
      this.validationErrors.rate = null;
    },
    bindModel(object) {
      this.reset();
      this.selectedAncillary = this.postbookingAncillaries.find(
        (a) => a.name == object.name
      );
      if (this.selectedAncillary == null) {
        this.selectedAncillary = {
          name: object.name,
        };
        this.postbookingAncillaries.push({
          name: object.name,
        });
      }
      this.isUpdate = true;
      this.resetValidation();
      this.model = Object.assign({}, object);
      this.newFareComponent.id = object.id;
      this.newFareComponent.name = this.selectedAncillary.name;
      this.newFareComponent.rate = object.rate;
      this.newFareComponent.quantity = object.quantity;
      this.calculateAncillaryTotal();
    },
    reset() {
      this.postbookingAncillaries = this.originalAncillaries;
      this.isUpdate = false;
      this.resetValidation();
      this.model = {};
      this.newFareComponent = {
        id: "",
        masterClassAncillaryId: "",
        quantity: 1,
      };
      this.newFareTotal = 0;
    },
    async getAll() {
      // const response = await inquiryReservationService.getById(
      //   this.selectedReservation.reservationId
      // );
      const response = await inquiryTenantJobService.getDetail(
        this.selectedReservation.reservationId
      );
      if (response != null) {
        this.reservationDetail.booker = response.booker;
        this.reservationDetail.driver = response.driver;
        this.reservationDetail.histories = response.histories;
        this.reservationDetail.pickUpLocation = response.pickUpLocation;
        this.reservationDetail.dropOffLocation = response.dropOffLocation;
        this.reservationDetail.pickUpDate = response.pickUpDate;
        this.reservationDetail.dropOffDate = response.dropOffDate;
        this.reservationDetail.code = response.code;
        // this.reservationDetail.className = response.className;
        this.reservationDetail.serviceType = response.serviceType;
        this.reservationDetail.reservationDate = response.reservationDate;
        // this.reservationDetail.passengers = response.passengers;
        this.reservationDetail.paymentStatus = response.paymentStatus;
        this.reservationDetail.currencyCode = response.moneyFormat.currencyCode;
        this.reservationDetail.grandTotal = response.grandTotal;
        this.reservationDetail.histories = response.histories;
        this.reservationDetail.fareComponents = response.fareComponents;
        if (
          this.reservationDetail.fareComponents != null &&
          this.reservationDetail.fareComponents.length > 0
        ) {
          var fareComponents = Array.prototype.slice.call(
            this.reservationDetail.fareComponents,
            0
          );
          this.reservationDetail.fareComponentsPreBooking = fareComponents.filter(
            (f) => f.category == "Selling" && f.isPreBooking == true
          );
          this.reservationDetail.buyingGrandTotal = this.reservationDetail.fareComponentsPreBooking.reduce(
            (a, b) => a + (b["rate"] || 0),
            0
          );
          this.reservationDetail.fareComponentsPostBooking = fareComponents.filter(
            (f) => f.category == "Selling" && f.isPreBooking == false
          );
        }
        this.calculateTotal();
      }
      const ancillaries = await extraService.getExtraServices();
      this.postbookingAncillaries = ancillaries;
      this.originalAncillaries = ancillaries;
    },
    changeAncillaryItem(event) {
      this.selectedAncillary = this.postbookingAncillaries.find(
        (a) => a.name == event.target.value
      );
      this.newFareComponent.name = this.selectedAncillary.name;
      this.newFareComponent.rate = this.selectedAncillary.rate;
      this.calculateAncillaryTotal();
    },
    calculateAncillaryTotal() {
      this.newFareTotal = this.newFareComponent.quantity * this.selectedAncillary.rate;
    },
    calculateTotal() {
      this.totalExtraService = this.reservationDetail.fareComponentsPostBooking.reduce(
        (accum, item) => accum + item.quantity * item.rate,
        0
      );
      this.totalCost = this.reservationDetail.grandTotal + this.totalExtraService;
    },
    isAirportTransfer: function () {
      return (
        this.reservationDetail &&
        this.reservationDetail.serviceType !== "" &&
        this.reservationDetail.serviceType.toLowerCase() === "airporttransfer"
      );
    },
    async approve() {
      try {
        this.isLoading = true;
        if (!this.isApproved()) {
          // Approve
          await depositSummaryService.inquiryRepriceDeduct({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Price successfully approved.", {
            title: "Success",
          });
          this.$notification.success("Deposit successfully deducted.", {
            title: "Success",
          });
          // Publish Invoice
          await inquiryProviderJobService.publishInvoice({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Invoice successfully published.", {
            title: "Success",
          });
          // Close Job
          await inquiryProviderJobService.closeReservation({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Reservation successfully closed.", {
            title: "Success",
          });
        } else if (!this.isInvoiced()) {
          await inquiryProviderJobService.publishInvoice({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Invoice successfully published.", {
            title: "Success",
          });
        }
        this.reset();
        // this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async reject() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.proposePriceReject({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Price Successfully Rejected.", { title: "Success" });
        this.reset();
        // this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async publishInvoice() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.publishInvoice({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Invoice successfully published.", {
          title: "Success",
        });
        this.reset();
        // this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async close() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.closeReservation({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Reservation successfully closed.", {
          title: "Success",
        });
        this.reset();
        // this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    isProposed: function () {
      try {
        let canApprove = false;
        canApprove =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          this.reservationDetail.histories[this.reservationDetail.histories.length - 1]
            .event == "PriceProposed";
        return canApprove;
      } catch (error) {
        return false;
      }
    },
    isApproved: function () {
      try {
        let canApprove = false;
        canApprove =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          this.reservationDetail.histories[this.reservationDetail.histories.length - 1]
            .event == "PriceApproved";
        return canApprove;
      } catch (error) {
        return false;
      }
    },
    isInvoiced: function () {
      try {
        let canApprove = false;
        canApprove =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          this.reservationDetail.histories[this.reservationDetail.histories.length - 1]
            .event == "Invoiced";
        return canApprove;
      } catch (error) {
        return false;
      }
    },
    isWaitForProposed: function () {
      try {
        let canApprove = false;
        canApprove =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          (this.reservationDetail.histories[this.reservationDetail.histories.length - 1]
            .event == "PriceRejected" ||
            this.reservationDetail.histories[this.reservationDetail.histories.length - 1]
              .event == "PassengerDropped");
        return canApprove;
      } catch (error) {
        return false;
      }
    },
    isCanPropose: function () {
      try {
        let canPropose = false;
        canPropose =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          (this.reservationDetail.histories[this.reservationDetail.histories.length - 1]
            .event == "PassengerDropped" ||
            this.reservationDetail.histories[this.reservationDetail.histories.length - 1]
              .event == "PriceRejected");
        return canPropose;
      } catch (error) {
        return false;
      }
    },
    async createItem() {
      try {
        this.isLoading = true;
        (this.model.reservationId = this.selectedReservation.reservationId),
          (this.newFareComponent.quantity = Number(this.newFareComponent.quantity));
        this.newFareComponent.id = null;
        this.newFareComponent.masterClassAncillaryId = null;
        this.newFareComponent.rate = Number(this.newFareComponent.rate);
        this.model.ancillaries = [this.newFareComponent];
        await inquiryProviderJobService.addPostbookingAncillary(this.model);
        this.$notification.success("Successfully added.", { title: "Success" });
        // await inquiryProviderJobService.repricePostbookingAncillary({
        //   reservationId: this.selectedReservation.reservationId,
        //   providerId: this.selectedReservation.providerId,
        // });
        // this.$notification.success("Successfully Repriced.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async updateItem(item) {
      if (!this.$helper.validateForm(this, "master-class-rental-rate-form")) {
        return;
      }
      try {
        this.isLoading = true;
        (this.model.reservationId = this.selectedReservation.reservationId),
          (this.newFareComponent.quantity = Number(this.newFareComponent.quantity));
        this.newFareComponent.masterClassAncillaryId = null;
        this.newFareComponent.rate = Number(this.newFareComponent.rate);
        this.model.ancillaries = [this.newFareComponent];
        await inquiryProviderJobService.updatePostbookingAncillary(this.model);
        this.$notification.success("Successfully updated.", { title: "Success" });
        // await inquiryProviderJobService.repricePostbookingAncillary({
        //   reservationId: this.selectedReservation.reservationId,
        //   providerId: this.selectedReservation.providerId,
        // });
        // this.$notification.success("Successfully Repriced.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.closeModal();
      this.$eventBus.$emit(
        "openProviderJobBrowserDeleteModal",
        "inquiryReservationFareComponent",
        item.id
      );
    },
    async deleteItem(id) {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.deletePostbookingAncillary(id);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        // await inquiryProviderJobService.repricePostbookingAncillary({
        //   reservationId: this.selectedReservation.reservationId,
        //   providerId: this.selectedReservation.providerId,
        // });
        // this.$notification.success("Successfully Repriced.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.openModal();
        this.isLoading = false;
      }
    },
    async propose() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.proposePrice({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Price Successfully Proposed.", { title: "Success" });
        this.reset();
        // this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async reprice() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.repricePostbookingAncillary({
          reservationId: this.selectedReservation.reservationId,
          providerId: this.selectedReservation.providerId,
        });
        this.$notification.success("Successfully Repriced.", { title: "Success" });
        this.reset();
        this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
#startPeriod-rental-input,
#endPeriod-rental-input {
  height: 35px !important;
  min-height: 35px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/job/tenantJob/TenantReservationReprice.vue